<template>
  <v-container>
    <v-row>
      <v-col md="12" class="text-center pa-5" >
        <h1>404</h1>
        <h3>This is not the page you are looking for :)</h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "404"
};
</script>
<style>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}
</style>
